/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// uploadPdfAndImage
// UPLOADPDFANDIMAGE
const GETALLUSERS= createAsyncThunk(
  "getAllUsers/getAllUsers",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getAllUsersSlice = createSlice({
  name: "getAllUsersSlice",
  initialState: {
    getAllUsers: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetAllUsers: (state) => {
        state.getAllUsers.loading = false
        state.getAllUsers.error = false
        state.getAllUsers.data = []
        state.getAllUsers.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETALLUSERS.fulfilled, (state, action) => {
      state.getAllUsers = {
        ...state.getAllUsers,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLUSERS.pending, (state, action) => {
      state.getAllUsers = {
        ...state.getAllUsers,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLUSERS.rejected, (state, action) => {
      state.getAllUsers = {
        ...state.getAllUsers,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getAllUsersAction = {
    GETALLUSERS,
};

export { getAllUsersAction };
export default getAllUsersSlice.reducer;
export const {setInitialStateOfgetAllUsers} = getAllUsersSlice.actions